import { axiosInstance } from './AxiosDefaults';
import { User } from '../models/User';

export let activeUser: User | undefined;

try {
    activeUser = JSON.parse(<string>localStorage.getItem('uos-portal-user'));
} catch (error) {
    activeUser = undefined;
};

export const getAccessToken = (username: string, password: any, otp: boolean = false): Promise<any> => {
    const data = {
        username: username,
        password: undefined,
        otp: undefined,
    };

    if (!otp) {
        data.password = password;
    } else {
        data.otp = password;
    }

    return axiosInstance.post(
        `/auth/token`,
        data,
        { withCredentials: false, headers: { 'Content-Type': 'application/json' } }
    );
};

export const sendResetPasswordLink = (email: string): Promise<any> => {
    const data = {
        email,
    };

    return axiosInstance.post(
        `/auth/reset-password`,
        data,
        { withCredentials: false, headers: { 'Content-Type': 'application/json' } }
    );
};

export const resetPassword = (passwordResetToken: string, newPassword: string): Promise<any> => {
    const data = {
        passwordResetToken,
        newPassword,
    };

    return axiosInstance.post(
        `/auth/reset-password`,
        data,
        { withCredentials: false, headers: { 'Content-Type': 'application/json' } }
    );
};

export const setUser = (data: User) => {
    activeUser = data;
    localStorage.setItem('uos-portal-user', JSON.stringify(data));
    localStorage.setItem('token', data.accessToken as string);
};

export const removeActiveUser = () => {
    activeUser = undefined;
    localStorage.removeItem('uos-portal-user');
    localStorage.removeItem('token');
};